import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Typography } from "@material-ui/core";
import withHeightChange from '../../HOC/withHeightChange';

const useStyles = theme => ({
    paper: {
        margin: theme.spacing(1),
        minHeight: "5vh",
        padding: theme.spacing(1)
    },
    title: {
        padding: theme.spacing(1)
    },
    content: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(1)
    }
});

const ReportDescription = forwardRef((props, ref) => {
    const { classes, title, content } = props;
    return (
        <Paper
            ref={ref}
            square
            className={classes.paper}
        >
            <Typography variant="subtitle1" className={classes.title}>
                {title}
            </Typography>
            <Typography variant="body1" className={classes.content}>
                {content}
            </Typography>
        </Paper>
    );
});

ReportDescription.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    content: PropTypes.string,
};

export default withStyles(useStyles)(withHeightChange(ReportDescription));
